import { initTransitions } from "./_transitions.js";
import { externalLinks } from "./_external-links";
import { scrollToTop } from "./_scroll-to-top";
import { initSlider } from "./_slider";
import { initPostSlider } from "./_post-slider";
import { initPrimaryNav } from "./_primary-nav";
import { initHeadroom } from "./_headroom";
import { initMediaTextTile } from "./_media-text-tile";
import { initVariableBg } from "./_variable-bg";
import { initAlert } from "./_alert";
import { initIframes } from "./_iframes";

/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

try {
    require("bootstrap");
} catch (e) {}

// inits
jQuery(function ($) {
    initHeadroom($);
    initPrimaryNav($);
    initAlert($);
    externalLinks($);
    initIframes($);

    scrollToTop("a.top-link");
    initSlider($);
    initVariableBg($);
    initPostSlider($);
    initMediaTextTile($);

    initTransitions($);

    // focus search field when dropdown opens
    $(".search-dropdown").on("shown.bs.dropdown", function () {
        $('[name="s"', this).focus();
    });

    $(".category-navigation select").on("change", function () {
        window.location.href = $(this).find(":selected").attr("data-url");
    });

    $(".translation-dropdown").on("change", function () {
        window.location.href = $(this).find(":selected").attr("data-url");
    });

    // window.addEventListener("scroll", function () {
	// 	const background = document.querySelector(".entry-header-bg");
	// 	const container = document.querySelector(".entry-header");
	// 	const rect = container.getBoundingClientRect();

	// 	// Initial position of the container from the top of the document
	// 	const initialOffset = container.offsetTop;

	// 	// Calculate the current scroll position relative to the initialOffset
	// 	const scrollOffset = window.scrollY - initialOffset;

	// 	// Only adjust the background if the container is within the viewport
	// 	if (rect.top <= window.innerHeight && rect.bottom >= 0) {
	// 		// Make sure we don't subtract too much initially to avoid jump
	// 		background.style.transform = `translateY(${Math.max(0, scrollOffset)}px)`;
	// 	}
	// });


});
